import Cookies from 'js-cookie'

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  sideLabel: {
    opened: false
  },
  device: 'desktop',
  checkLabel: '',
  role: localStorage.getItem('role')
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  TOGGLE_SIDELABEL: (state, opened) => {
    state.sideLabel.opened = opened
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SETCHECKLABEL: (state, checkLabel) => {
    state.checkLabel = checkLabel
  },
  SET_ROLE: (state, role) => {
    localStorage.setItem('role', role)
    state.role = role
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  toggleSideLabel({ commit }, opened) {
    commit('TOGGLE_SIDELABEL', opened)
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setCheckLabel({ commit }, checkLabel) {
    commit('SETCHECKLABEL', checkLabel)
  },
  setRole({ commit }, role) {
    commit('SET_ROLE', role)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
